{
  "dropLabel": "Peke ki tētahi pātai motuhake",
  "nextLabel": "<b>Whakautua ngā pātai hauora</b>",
  "questions": {
    "allergies": {
      "detailsPlaceholder": "Tēnā tuhi mai ki te reo Pākehā. Hei tauira:<br/>\nPenicillin – rash and swelling; Latex – mild irritation",
      "label": "He mate pāwera āu?",
      "nextLabel": "$t(common:next): <b>Taumaha me te teitei</b>",
      "title": "<h3>Ngā mate pāwera (Allergies)</h3>"
    },
    "arrhythmias": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>Irregular heartbeat, on beta blockers since 2021",
      "label": "He patuki manawa rangirua, he kiriweti, he haruru manawa āu?",
      "nextLabel": "$t(common:next): <b>Pūoko manawa</b>",
      "title": "<h3>Taiahoaho o te manawa (Arrhythmias)</h3>"
    },
    "asthmaLungConditions": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira:<br/>\nMild asthma – use inhaler occasionally",
      "label": "He mate huangō, COPD, āhua mate rānei āu e pā ana ki ngā pūkahukahu?",
      "nextLabel": "$t(common:next): <b>Mate kōpū</b>",
      "title": "<h3>Mate huangō, mate pūkahukahu rānei (Asthma or lung conditions)</h3>"
    },
    "bloodProblems": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>\nEasy bruising – diagnosed with Von Willebrand disease",
      "label": "He GORD (rewharewha), IBS, IBD rānei āu?",
      "nextLabel": "$t(common:next): <b>Whakakapi okana</b>",
      "title": "<h3>Ngā raruraru toto, pērā i te pakukaha, te toto rere nui rānei (Blood disorders or bleeding problems)</h3>"
    },
    "bloodThinningMedication": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>Apixaban – 5mg daily, last taken on 3 June",
      "label": "Kei te kai rongoā whakarewa toto koe ināianei?",
      "nextLabel": "$t(common:next): <b>Mate manawa</b>",
      "title": "<h3>Rongoā whakaheke toto (Blood thinning medication)</h3>"
    },
    "cancerTreatment": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>\nChemotherapy for breast cancer – ongoing",
      "label": "Kei te whiwhi koe i te rongoā patu matepukupuku penei i te whakamomori, te irarua rānei, i tētahi atu momo maimoatanga hoki?",
      "nextLabel": "$t(common:next): <b>Ngā mate urutā</b>",
      "title": "<h3>Te maimoatanga matepukupuku (Cancer treatment)</h3>"
    },
    "diabetes": {
      "detailsLabel": "E pēhea ana te whakahaere i tō mate huka?",
      "diet-controlled": "Ka whakahaeretia mā te kai",
      "insulin": "Inuha",
      "label": "He mate huka āu?",
      "nextLabel": "$t(common:next): <b>Pēhanga toto teitei</b>",
      "no": "Kāo",
      "tablets": "Pāpāho (hei tauira: Metformin)",
      "title": "<h3>Mate huka (Diabetes)</h3>",
      "type-1": "Momo 1 – kei te whakamahi i te insulini",
      "type-2": "Momo 2",
      "yes-type-1": "Āe – Momo 1, kei te whakamahi i te insulin",
      "yes-type-2": "Āe – Momo 2"
    },
    "digestiveConditions": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira:<br/>Reflux managed with omeprazole",
      "label": "He GORD (rewharewha), IBS, IBD rānei āu?",
      "nextLabel": "$t(common:next): <b>Raru toto, tūkinotanga rānei</b>",
      "title": "<h3>Ngā mate whakatōkai (Digestive conditions)</h3>"
    },
    "epilepsy": {
      "detailsPlaceholder": "Tēnā tuhi mai ki te reo Pākehā. Hei tauira:<br/>\nLast seizure in 2020 – currently stable",
      "label": "He mate hukihuki tō, kua pāngia rānei koe e ngā parekura i mua?",
      "nextLabel": "$t(common:next): <b>Ngā mate roro</b>",
      "title": "<h3>Mate hihira (Epilepsy)</h3>"
    },
    "heartConditions": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>Heart attack in 2020 – stent inserted",
      "label": "Kua pāngia koe e tētahi mate manawa i mua (pēnei i te mate manawa ohorere, te māmā o te ūnga manawa)?",
      "nextLabel": "$t(common:next): <b>Mate roro, TIA</b>",
      "title": "<h3>Ngā mate manawa (Heart conditions)</h3>"
    },
    "highBloodPressure": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira <br/>\nDiagnosed in 2018 – managed with medication",
      "label": "He pēhanga toto teitei āu?",
      "nextLabel": "$t(common:next): <b>Kupu manawa pōroheke</b>",
      "title": "<h3>Pēhanga toto teitei (High blood pressure)</h3>"
    },
    "infectiousDiseases": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>\nMRSA – cleared after treatment in 2021",
      "label": "Kua puta he hua pai i a koe mō te MRSA, ESBL, VRE, CPE rānei?",
      "nextLabel": "$t(common:next): <b>Hāpūtanga</b>",
      "title": "<h3>Ngā rauropi aukati-maha (Multi-resistant organisms)</h3>"
    },
    "metalImplants": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>Right hip replacement (2020), dental implants, or metal rod in leg",
      "label": "He momo whakaurunga konganuku kei tō tinana? (pēnei i te pūoko manawa, he kōiwi whakakapi rānei)",
      "nextLabel": "$t(common:next): <b>Mate huka</b>",
      "title": "<h3>Kua whakatōhia rānei he konganuku (Implants or metal)</h3>"
    },
    "obstructiveSleepApnoea": {
      "detailsPlaceholder": "Tāuruhia tēnei kōrero ki te reo Pākehā. Hei tauira:<br/>\nDiagnosed in 2022 – use CPAP machine every night",
      "label": "Kei a koe te mate moe tāwhatiwhati, ā, e whakamahi ana koe i te mīhini CPAP i te pō e moe ana?",
      "nextLabel": "$t(common:next): <b>Mate huangō, ā, he raru rānei ki ngā pūkahukahu</b>",
      "title": "<h3>Te ārai moe hā o te po (Obstructive Sleep Apnoea)</h3>"
    },
    "organTransplant": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>\nKidney transplant in 2018 – taking tacrolimus and prednisone",
      "label": "Kua whiwhi kē koe i tētahi whakakōkī okana, ā, kei te kai rongoā aukati ārai mate rānei?",
      "nextLabel": "$t(common:next): <b>Maimoatanga matepukupuku</b>",
      "title": "<h3>Te whakawhitinga okana (Organ transplant)</h3>"
    },
    "otherHealthConditions": {
      "detailsPlaceholder": "Tēnā whakakīhia mā te reo Pākehā. Hei tauira: <br/>\nCoeliac disease, recent surgery, chronic pain",
      "label": "He atu āhuatanga hauora, āwangawanga rānei e tika ana mā mātou e mōhio?",
      "nextLabel": "$t(common:next): <b>Ngā rongoā</b>",
      "title": "<h3>Ētahi atu āhuatanga hauora (Other health conditions)</h3>"
    },
    "pacemaker": {
      "defibrillator": "Pūoko whakaora manawa",
      "detailsLabel": "He aha te momo?",
      "label": "Kei a koe tētahi taputapu ā-roro manawa, ā-tāuta rānei mō te manawa?",
      "nextLabel": "$t(common:next): <b>Rongoā whakaheke toto</b>",
      "not-sure": "Kāore au i te mōhio",
      "pacing": "Pēhinga",
      "title": "<h3>Pūkaha manawa, he pūrere cardiac kua whakatōhia (Pacemaker or implanted cardiac device)</h3>"
    },
    "pregnancy": {
      "label": "Kei te hapū koe ināianei – ākene pea?",
      "nextLabel": "$t(common:next): <b>Ētahi atu mate</b>",
      "title": "<h3>Te hapūtanga (Pregnancy)</h3>"
    },
    "stroke": {
      "detailsPlaceholder": "Tēnā tuhi mai ki te reo Pākehā. Hei tauira:<br/>\nStroke in 2021 – mild weakness on left side",
      "label": "Kua pāngia koe e te tukituki roro, i te tukituki roro iti rānei (TIA)?",
      "nextLabel": "$t(common:next): <b>Mate roro hiko (Epilepsy)</b>",
      "title": "<h3>Pate roro, rānei he mate iti (TIA)</h3>"
    },
    "weightHeight": {
      "cm": "cm",
      "height": "Teitei",
      "kg": "kg",
      "nextLabel": "$t(common:next): <b>Kōmiti / konganuku</b>",
      "text": "Tēnā, tāuruhia tō taumaha me tō teitei tata.",
      "title": "<h3>Taumaha me te teitei</h3><p>Tēnā, tāuruhia tō taumaha me tō teitei tata.</p>",
      "weight": "Taumaha"
    }
  },
  "text": "<p>Kua tata mutu.</p>\n<p>Me pātai noa atu mātou i ētahi pātai mō tō hauora, āu rongoā, me ō hiahia.</p>\n<p>He mea nui kia mārama mātou ki ngā mea ka pā pea ki tō tiaki.</p>\n<p>Mēnā me whakamārama ētahi mea, ka whakapā atu tētahi o tō mātou tīma i mua i tō hāparatanga.</p>\n<p>He iti iho i te <strong>10 meneti</strong> te wā e pau mō tēnei wāhanga whakamutunga.</p>",
  "title": "Ngā pātai hauora me ngā manako"
}
